module.exports = __webpack_public_path__ + "static/media/id11-9.9ef153f7.png";